<template>

    <div :id="tableContainerId" class="table_wrapper">

        <table class="table">
            <thead class="table_head">
                <slot name="tableHead"></slot>
            </thead>
            <tbody class="table_body">
                <slot name="tableBody" /></slot>
            </tbody>
            <tfoot>
                <slot name="tableFoot" /></slot>
            </tfoot>
        </table>

        <slot name="tableHelpers" /></slot>

    </div>

</template>

<script>
export default {
    name: 'TableWrapper',
    props: ["tableContainerId"]
}
</script>

<style lang="scss">

.table_wrapper{
    .table{
        width: 100%;
        .table_head{
            font-weight: 600;
            color: $grey;
            text-transform: uppercase;
            th{
                height: $table-head-height;
                align-items: center;
            }
        }
        .table_body{
            tr{
                transition: .5s all;
                td{
                    height: $table-row-height;
                    padding-top: 12px;
                    padding-bottom: 12px;
                    vertical-align: middle;
                    &.icon_td{
                        max-width: 50px;
                        min-width: 50px;
                        width: 50px;
                        font-size: 1.2rem;
                        svg{
                            width: 22px;
                            fill: $grey-light;
                            transition: .3s all;
                        }
                        &:hover{
                            svg{
                                fill: $info;
                            }
                        }
                    }
                    &.with_dropslide{
                        overflow: hidden;
                    }
                }
                &.onDelete{
                    background: $danger;
                }
            }
        }
        .table-button{
            font-size: .9rem;
            font-weight: 500;
        }
        .padded_content{
            margin-left: 36px;
        }

    }
}
</style>